import { useEffect } from "react";

export function usePageTitle(title: string, name?: string) {
  useEffect(() => {
    document.title = name?.trim() ? `${title} - ${name}` : title;
  }, [name, title]);
}
